import { render, staticRenderFns } from "./EmployeeByGrade.vue?vue&type=template&id=230f3594&scoped=true&"
import script from "./EmployeeByGrade.vue?vue&type=script&lang=js&"
export * from "./EmployeeByGrade.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeByGrade.vue?vue&type=style&index=0&id=230f3594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f3594",
  null
  
)

export default component.exports